<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <div
      class="
        flex
        items-center
        text-white text-center
        font-bold
        py-2
        px-6
        my-8
        border-2 border-white
        rounded-full
      "
    >
      <PauseIcon class="mr-2" />
      {{ currentPhase }} is paused
    </div>

    <p class="text-white text-center" v-if="isClinician">
      Your are not streaming anything to the
      <br />
      attendees until you continue.
    </p>
    <p class="text-white text-center" v-else>
      Please wait until the VCE Clinician
      <br />
      continues the {{ currentPhase.toLowerCase() }}.
    </p>
  </div>
</template>

<script>
import PauseIcon from '@/Components/Icons/PauseIcon';

export default {
  props: {
    currentPhase: {
      type: String,
      default: 'Session',
    },
    isClinician: {
      type: Boolean,
      default: false,
    },
  },
  name: 'SessionPausedNotification',
  components: {
    PauseIcon,
  },
};
</script>
